import BaseModelAPI from '../BaseModelAPI';

export default class ReportPoPembelian extends BaseModelAPI {
    static entity = 'newreport1998';
    static entityName = 'reportpopembelian';

    constructor() {
        super();
        /*APP_MODEL_DEFINITION*/
        this.filterVendor = '';
        this.filterPart = '';
        this.filterPoNumber = '';
        this.filterPoDate = '';
        this.filterCustomer = '';
        this.filterPartSpecification = '';
        this.filterStatusDelivery = '';
        this.tempId = 0;
        this.supplierCode = '';
        this.supplierName = '';
        this.customerCode = '';
        this.customerName = '';
        this.partNumber = '';
        this.partSpecification = '';
        this.purchaseOrderNumber = '';
        this.qtyPo = 0;
        this.qtyActual = 0;
        this.balance = 0;
        this.balance = 0;
        this.priceProduct = 0;
        this.amount = 0;
        this.uom = '';
        this.statusDelivery = '';
        this.purchaseOrderDate = '';
        this.isFromUpload = false;
        this.isSavedToBackend = true;
        this.uploadValidationMessage = '';
        this.uploadValidationStatus = '';
        /*END_APP_MODEL_DEFINITION*/
    }

}